let conf = [
  // {
  //   id: 'FIFI',
  //   // color: '#29b4fb',
  //   bigAvatar: [
  //     require('./assets/big/big01.gif'),
  //     require('./assets/big/big02.gif'),
  //     require('./assets/big/big03.gif'),
  //     require('./assets/big/big04.gif'),
  //   ],
  //   successGif: require('./assets/big/big00.gif'),
  //   smallAvatar: require('./assets/big/big00.gif'),
  //   gameCheckSwitchStyle: {
  //     height: '522px',
  //   },
  //   communication: {
  //     right: [
  //       {
  //         text: 'Gratulacje! Wyśmienicie sobie poradziłeś!',
  //         sound: require('./sound/00/t01.mp3'),
  //       },
  //       {
  //         text: 'Brawo! Wspaniale ci poszło!',
  //         sound: require('./sound/00/t02.mp3'),
  //       },
  //       {
  //         text: 'Świetnie! Masz głowę nie od parady!',
  //         sound: require('./sound/00/t03.mp3'),
  //       },
  //       {
  //         text: 'Gratulacje! Zasługujesz na brawa!',
  //         sound: require('./sound/00/t04.mp3'),
  //       },
  //       {
  //         text: 'Jesteś mistrzem. Gratulacje!',
  //         sound: require('./sound/00/t05.mp3'),
  //       },
  //       {
  //         text: 'Poszło ci bardzo dobrze!',
  //         sound: require('./sound/00/t06.mp3'),
  //       },
  //       {
  //         text: 'Świetnie ci poszło! Gratulacje.',
  //         sound: require('./sound/00/t07.mp3'),
  //       },
  //       {
  //         text: 'Gratulacje! Spisałeś się na medal!',
  //         sound: require('./sound/00/t08.mp3'),
  //       },
  //       {
  //         text: 'Gratulacje! Świetnie sobie poradziłeś!',
  //         sound: require('./sound/00/t09.mp3'),
  //       },
  //     ],
  //     fault: [
  //       {
  //         text: 'Bądź dobrej myśli. Spróbuj jeszcze raz.',
  //         sound: require('./sound/00/f01.mp3'),
  //       },
  //       {
  //         text: 'Następnym razem pójdzie ci lepiej. Spróbuj jeszcze raz.',
  //         sound: require('./sound/00/f02.mp3'),
  //       },
  //       {
  //         text: 'Niestety, tym razem się nie udało. Spróbuj jeszcze raz.',
  //         sound: require('./sound/00/f03.mp3'),
  //       },
  //       {
  //         text: 'Na pewno tym razem pójdzie ci lepiej.',
  //         sound: require('./sound/00/f04.mp3'),
  //       },
  //       {
  //         text: 'Niestety, nie wszystko dobrze poszło. Spróbuj jeszcze raz.',
  //         sound: require('./sound/00/f05.mp3'),
  //       },
  //       {
  //         text: 'Na pewno dasz radę wykonać to poprawnie.',
  //         sound: require('./sound/00/f06.mp3'),
  //       },
  //       {
  //         text: 'Na pewno potrafisz wykonać to poprawnie.',
  //         sound: require('./sound/00/f07.mp3'),
  //       },
  //       {
  //         text: 'Spróbuj jeszcze raz. Na pewno dasz radę.',
  //         sound: require('./sound/00/f08.mp3'),
  //       },
  //       {
  //         text: 'Nie poddawaj się. Spróbuj jeszcze raz.',
  //         sound: require('./sound/00/f09.mp3'),
  //       },
  //     ],
  //   },
  // },
  // {
  //   id: 'MELA',
  //   bigAvatar: [
  //     require('./assets/big/big11.gif'),
  //     require('./assets/big/big12.gif'),
  //     require('./assets/big/big13.gif'),
  //     require('./assets/big/big14.gif'),
  //   ],
  //   // color: '#29b4fb',
  //   successGif: require('./assets/big/big10.gif'),
  //   smallAvatar: require('./assets/big/big10.gif'),
  //   gameCheckSwitchStyle: {
  //     height: '522px',
  //   },
  //   communication: {
  //     right: [
  //       {
  //         text: 'Gratulacje! Wyśmienicie sobie poradziłeś!',
  //         sound: require('./sound/01/t01.mp3'),
  //       },
  //       {
  //         text: 'Brawo! Wspaniale ci poszło!',
  //         sound: require('./sound/01/t02.mp3'),
  //       },
  //       {
  //         text: 'Świetnie! Masz głowę nie od parady!',
  //         sound: require('./sound/01/t03.mp3'),
  //       },
  //       {
  //         text: 'Gratulacje! Zasługujesz na brawa!',
  //         sound: require('./sound/01/t04.mp3'),
  //       },
  //       {
  //         text: 'Jesteś mistrzem. Gratulacje!',
  //         sound: require('./sound/01/t05.mp3'),
  //       },
  //       {
  //         text: 'Poszło ci bardzo dobrze!',
  //         sound: require('./sound/01/t06.mp3'),
  //       },
  //       {
  //         text: 'Świetnie ci poszło! Gratulacje.',
  //         sound: require('./sound/01/t07.mp3'),
  //       },
  //       {
  //         text: 'Gratulacje! Spisałeś się na medal!',
  //         sound: require('./sound/01/t08.mp3'),
  //       },
  //       {
  //         text: 'Gratulacje! Świetnie sobie poradziłeś!',
  //         sound: require('./sound/01/t09.mp3'),
  //       },
  //     ],
  //     fault: [
  //       {
  //         text: 'Bądź dobrej myśli. Spróbuj jeszcze raz.',
  //         sound: require('./sound/01/f01.mp3'),
  //       },
  //       {
  //         text: 'Następnym razem pójdzie ci lepiej. Spróbuj jeszcze raz.',
  //         sound: require('./sound/01/f02.mp3'),
  //       },
  //       {
  //         text: 'Niestety, tym razem się nie udało. Spróbuj jeszcze raz.',
  //         sound: require('./sound/01/f03.mp3'),
  //       },
  //       {
  //         text: 'Na pewno tym razem pójdzie ci lepiej.',
  //         sound: require('./sound/01/f04.mp3'),
  //       },
  //       {
  //         text: 'Niestety, nie wszystko dobrze poszło. Spróbuj jeszcze raz.',
  //         sound: require('./sound/01/f05.mp3'),
  //       },
  //       {
  //         text: 'Na pewno dasz radę wykonać to poprawnie.',
  //         sound: require('./sound/01/f06.mp3'),
  //       },
  //       {
  //         text: 'Na pewno potrafisz wykonać to poprawnie.',
  //         sound: require('./sound/01/f07.mp3'),
  //       },
  //       {
  //         text: 'Spróbuj jeszcze raz. Na pewno dasz radę.',
  //         sound: require('./sound/01/f08.mp3'),
  //       },
  //       {
  //         text: 'Nie poddawaj się. Spróbuj jeszcze raz.',
  //         sound: require('./sound/01/f09.mp3'),
  //       },
  //     ],
  //   },
  // },
  {
    id: 'POLA',
    bigAvatar: [
      // require('./assets/big/big21.gif'),
      // require('./assets/big/big22.gif'),
      // require('./assets/big/big23.gif'),
      // require('./assets/big/big24.gif'),
    ],
    // color: '#65b26c',
    // successGif: require('./assets/big/big20.gif'),
    // smallAvatar: require('./assets/big/big20.gif'),
    successGif: '',
    smallAvatar: '',
    gameCheckSwitchStyle: {
      height: '522px',
    },
    communication: {
      right: [
        {
          text: 'Gratulacje! Wyśmienicie sobie poradziłeś!',
          sound: require('./sound/02/t01.mp3'),
        },
        // {
        //   text: 'Brawo! Wspaniale ci poszło!',
        //   sound: require('./sound/02/t02.mp3'),
        // },
        // {
        //   text: 'Świetnie! Masz głowę nie od parady!',
        //   sound: require('./sound/02/t03.mp3'),
        // },
        // {
        //   text: 'Gratulacje! Zasługujesz na brawa!',
        //   sound: require('./sound/02/t04.mp3'),
        // },
        // {
        //   text: 'Jesteś mistrzem. Gratulacje!',
        //   sound: require('./sound/02/t05.mp3'),
        // },
        // {
        //   text: 'Poszło ci bardzo dobrze!',
        //   sound: require('./sound/02/t06.mp3'),
        // },
        // {
        //   text: 'Świetnie ci poszło! Gratulacje.',
        //   sound: require('./sound/02/t07.mp3'),
        // },
        // {
        //   text: 'Gratulacje! Spisałeś się na medal!',
        //   sound: require('./sound/02/t08.mp3'),
        // },
        // {
        //   text: 'Gratulacje! Świetnie sobie poradziłeś!',
        //   sound: require('./sound/02/t09.mp3'),
        // },
      ],
      fault: [
        {
          text: 'Bądź dobrej myśli. Spróbuj jeszcze raz.',
          sound: require('./sound/02/f01.mp3'),
        },
        // {
        //   text: 'Następnym razem pójdzie ci lepiej. Spróbuj jeszcze raz.',
        //   sound: require('./sound/02/f02.mp3'),
        // },
        // {
        //   text: 'Niestety, tym razem się nie udało. Spróbuj jeszcze raz.',
        //   sound: require('./sound/02/f03.mp3'),
        // },
        // {
        //   text: 'Na pewno tym razem pójdzie ci lepiej.',
        //   sound: require('./sound/02/f04.mp3'),
        // },
        // {
        //   text: 'Niestety, nie wszystko dobrze poszło. Spróbuj jeszcze raz.',
        //   sound: require('./sound/02/f05.mp3'),
        // },
        // {
        //   text: 'Na pewno dasz radę wykonać to poprawnie.',
        //   sound: require('./sound/02/f06.mp3'),
        // },
        // {
        //   text: 'Na pewno potrafisz wykonać to poprawnie.',
        //   sound: require('./sound/02/f07.mp3'),
        // },
        // {
        //   text: 'Spróbuj jeszcze raz. Na pewno dasz radę.',
        //   sound: require('./sound/02/f08.mp3'),
        // },
        // {
        //   text: 'Nie poddawaj się. Spróbuj jeszcze raz.',
        //   sound: require('./sound/02/f09.mp3'),
        // },
      ],
    },
  },
  // {
  //   id: 'OLO',
  //   bigAvatar: [
  //     require('./assets/big/big31.gif'),
  //     require('./assets/big/big32.gif'),
  //     require('./assets/big/big33.gif'),
  //     require('./assets/big/big34.gif'),
  //   ],
  //   // color: '#fb6169',
  //   successGif: require('./assets/big/big30.gif'),
  //   smallAvatar: require('./assets/big/big30.gif'),
  //   gameCheckSwitchStyle: {
  //     height: '522px',
  //   },
  //   communication: {
  //     right: [
  //       {
  //         text: 'Gratulacje! Wyśmienicie sobie poradziłeś!',
  //         sound: require('./sound/03/t01.mp3'),
  //       },
  //       {
  //         text: 'Brawo! Wspaniale ci poszło!',
  //         sound: require('./sound/03/t02.mp3'),
  //       },
  //       {
  //         text: 'Świetnie! Masz głowę nie od parady!',
  //         sound: require('./sound/03/t03.mp3'),
  //       },
  //       {
  //         text: 'Gratulacje! Zasługujesz na brawa!',
  //         sound: require('./sound/03/t04.mp3'),
  //       },
  //       {
  //         text: 'Jesteś mistrzem. Gratulacje!',
  //         sound: require('./sound/03/t05.mp3'),
  //       },
  //       {
  //         text: 'Poszło ci bardzo dobrze!',
  //         sound: require('./sound/03/t06.mp3'),
  //       },
  //       {
  //         text: 'Świetnie ci poszło! Gratulacje.',
  //         sound: require('./sound/03/t07.mp3'),
  //       },
  //       {
  //         text: 'Gratulacje! Spisałeś się na medal!',
  //         sound: require('./sound/03/t08.mp3'),
  //       },
  //       {
  //         text: 'Gratulacje! Świetnie sobie poradziłeś!',
  //         sound: require('./sound/03/t09.mp3'),
  //       },
  //     ],
  //     fault: [
  //       {
  //         text: 'Bądź dobrej myśli. Spróbuj jeszcze raz.',
  //         sound: require('./sound/03/f01.mp3'),
  //       },
  //       {
  //         text: 'Następnym razem pójdzie ci lepiej. Spróbuj jeszcze raz.',
  //         sound: require('./sound/03/f02.mp3'),
  //       },
  //       {
  //         text: 'Niestety, tym razem się nie udało. Spróbuj jeszcze raz.',
  //         sound: require('./sound/03/f03.mp3'),
  //       },
  //       {
  //         text: 'Na pewno tym razem pójdzie ci lepiej.',
  //         sound: require('./sound/03/f04.mp3'),
  //       },
  //       {
  //         text: 'Niestety, nie wszystko dobrze poszło. Spróbuj jeszcze raz.',
  //         sound: require('./sound/03/f05.mp3'),
  //       },
  //       {
  //         text: 'Na pewno dasz radę wykonać to poprawnie.',
  //         sound: require('./sound/03/f06.mp3'),
  //       },
  //       {
  //         text: 'Na pewno potrafisz wykonać to poprawnie.',
  //         sound: require('./sound/03/f07.mp3'),
  //       },
  //       {
  //         text: 'Spróbuj jeszcze raz. Na pewno dasz radę.',
  //         sound: require('./sound/03/f08.mp3'),
  //       },
  //       {
  //         text: 'Nie poddawaj się. Spróbuj jeszcze raz.',
  //         sound: require('./sound/03/f09.mp3'),
  //       },
  //     ],
  //   },
  //   // successIcon: require('./assets/big/big0.png'),
  // },
];
export default conf;
